import { SparseAsset } from '@/asset/api/types';
import { SparseProject } from '@/sparse/api/types';
import { CreateTicket } from '@/ticket/components/create-ticket';
import { Dialog, DialogTitle } from '@mui/material';

/**
 * Properties for the CreateTicketDialog component.
 *
 * @property {boolean} isOpen - Indicates whether the dialog is open or closed.
 * @property {function} onClose - Callback function triggered when the dialog is closed.
 * @property {SparseAsset[]} [forAssetIds] - Optional array of asset IDs associated with the ticket.
 * @property {SparseProject[]} [forProjectIds] - Optional array of project IDs associated with the ticket.
 * @property {function} [onSuccess] - Optional callback function triggered when ticket is created successfully.
 * @property {string[][]} [additionalQueryKeys] - Optional array of query keys to invalidate on success.
 */
interface CreateTicketDialogProps {
  isOpen: boolean;
  onClose: () => void;
  forAssetIds?: SparseAsset[];
  forProjectIds?: SparseProject[];
  onSuccess?: () => void;
  additionalQueryKeys?: string[][];
}

export function CreateTicketDialog({
  isOpen,
  onClose,
  forProjectIds,
  forAssetIds,
  onSuccess,
  additionalQueryKeys,
}: CreateTicketDialogProps) {
  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Open ticket</DialogTitle>
      <CreateTicket
        onClose={onClose}
        forAssetIds={forAssetIds}
        forProjectIds={forProjectIds}
        onSuccess={onSuccess}
        additionalQueryKeys={additionalQueryKeys}
      />
    </Dialog>
  );
}
